"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12m1.23 0A8.77 8.77 0 0 1 12 3.23 8.79 8.79 0 0 1 20.77 12a8.77 8.77 0 0 1-17.54 0m11.93-1.96a3.16 3.16 0 1 1-6.32 0 3.16 3.16 0 0 1 6.32 0m2.72 7.26a7.91 7.91 0 0 1-11.67 0v-.17a3.35 3.35 0 0 1 3.33-3.34h5a3.35 3.35 0 0 1 3.34 3.34z",
        clipRule: "evenodd"
      }
    )
  }
), c = e(m);
export {
  c as AccountFilled,
  c as default
};
